module.exports = __webpack_public_path__ + "static/media/radio.25caeeff.svg";